import axios from "axios"; // only for refresh API (important)
import axiosInstance from "../utils/authUtils";
import { API_PATHS, API_BASE_URL } from "../utils/constants/api.constants";

class AuthService {
  
  static requestLoginOtp(item) {
    return axiosInstance
      .post(API_PATHS.login, item)
      .then((res) => res.data);
  }

static otpVerification({ email, mobileNumber, otp }) {
  console.log("OTP FUNCTION CALLED");

  return axiosInstance
    .post(API_PATHS.verifyotp, { email, mobileNumber, otp })
    .then((res) => {
      console.log("SUCCESS RESPONSE:", res);

      const data = res.data?.data;

      console.log("PARSED DATA:", data);

      if (data) {
        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("user", JSON.stringify(data));
      }

      return res.data;
    })
    .catch((err) => {
      console.log("ERROR:", err.response || err);
      throw err;
    });
}

  static async generateNewAccessToken() {
    const refreshToken = localStorage.getItem("refreshToken");
    const res = await axios.post(
      API_BASE_URL + API_PATHS.generateNewAccessToken,
      { refreshToken }
    );

    const newAccessToken = res.data.accessToken;
    localStorage.setItem("accessToken", newAccessToken);

    return newAccessToken;
  }

  static register(item) {
    return axiosInstance
      .post(API_PATHS.signup, item)
      .then((res) => res.data);
  }

  static getProfile(payload = {}) {
    return axiosInstance
      .get(API_PATHS.getProfile, {
        params: payload,
      })
      .then((response) => response.data);
  }

  static removeUserDetails() {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }

  static getUserDetails() {
    return JSON.parse(localStorage.getItem("user"));
  }
}

export default AuthService;